import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import { muiTheme } from "./theme";
import { ContactSelect } from "./pages/ContactSelect";
import { Layout } from "./layouts";
import { ThemeProvider } from "@emotion/react";
import AssignContact from "./pages/AssignContact/AssignContact";
import SubscribeSuccess from "./pages/SubscribeSuccess/SubscribeSuccess";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import Subscribe from "./pages/Subscribe/Subscribe";
import Unsubscribe from "./pages/Unsubscribe/Unsubscribe";
import ExcludeDomain from "./pages/ExcludeDomain/ExcludeDomain";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./firebase";
import { Navigate } from "react-router-dom";
import Login from "./pages/Login/Login";
import "./axiosSetup";

function RequireAuth({ children }: { children: JSX.Element }) {
  const [ready, setReady] = React.useState(false);
  const [user, setUser] = React.useState<any>(null);
  React.useEffect(
    () =>
      onAuthStateChanged(auth, (u) => {
        setUser(u);
        setReady(true);
      }),
    []
  );
  if (!ready) return null;
  if (!user)
    return (
      <Navigate
        to={`/login?next=${encodeURIComponent(
          window.location.pathname + window.location.search
        )}`}
        replace
      />
    );
  return children;
}

const router = createBrowserRouter([
  { path: "/login", element: <Login /> },
  {
    path: "/select-contact",
    element: (
      <RequireAuth>
        <ContactSelect />
      </RequireAuth>
    ),
  },
  {
    path: "/assign-contact",
    element: (
      <RequireAuth>
        <AssignContact />
      </RequireAuth>
    ),
  },
  {
    path: "/",
    element: (
      <RequireAuth>
        <SubscribeSuccess />
      </RequireAuth>
    ),
  },
  {
    path: "/subscribe",
    element: (
      <RequireAuth>
        <Subscribe />
      </RequireAuth>
    ),
  },
  {
    path: "/unsubscribe",
    element: (
      <RequireAuth>
        <Unsubscribe />
      </RequireAuth>
    ),
  },
  {
    path: "/exclude-domain",
    element: (
      <RequireAuth>
        <ExcludeDomain />
      </RequireAuth>
    ),
  },
  { path: "*", element: <h1>This page does not exist</h1> },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <ThemeProvider theme={muiTheme}>
    <QueryClientProvider client={queryClient}>
      <Layout>
        <RouterProvider router={router} />
      </Layout>
    </QueryClientProvider>
  </ThemeProvider>
);
